import React, { useEffect, useState } from "react";
import "../static/Jobs.css";

function Jobs() {
  const [jobs, setJobs] = useState([]);
  const [search, setSearch] = useState("");
  const [typeFilter, setTypeFilter] = useState("All");

  useEffect(() => {
    try {
      const storedJobs =
        JSON.parse(localStorage.getItem("qauraJobs")) || [];

      // IMPORTANT: avoid mutating original array
      const reversedJobs = [...storedJobs].reverse();

      setJobs(reversedJobs);
    } catch (error) {
      console.error("Error loading jobs:", error);
      setJobs([]);
    }
  }, []);

  // Filter Logic
  const filteredJobs = jobs.filter((job) => {
    const matchesSearch =
      job.title?.toLowerCase().includes(search.toLowerCase()) ||
      job.company?.toLowerCase().includes(search.toLowerCase());

    const matchesType =
      typeFilter === "All" || job.type === typeFilter;

    return matchesSearch && matchesType;
  });

  return (
    <div className="jobs-wrapper">
      <div className="stars"></div>

      <h1>Latest Job Openings</h1>

      {/* Search & Filter */}
      <div className="jobs-controls">
        <input
          type="text"
          placeholder="Search by title or company..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="jobs-search"
        />

        <select
          value={typeFilter}
          onChange={(e) => setTypeFilter(e.target.value)}
          className="jobs-filter"
        >
          <option value="All">All</option>
          <option value="Full-time">Full-time</option>
          <option value="Internship">Internship</option>
          <option value="Part-time">Part-time</option>
          <option value="Remote">Remote</option>
        </select>
      </div>

      <p className="job-count">
        Showing {filteredJobs.length} job
        {filteredJobs.length !== 1 && "s"}
      </p>

      <div className="jobs-container">
        {filteredJobs.length === 0 ? (
          <div className="no-jobs">
            <h3>No jobs found 😔</h3>
            <p>Try changing search or filter options.</p>
          </div>
        ) : (
          filteredJobs.map((job) => (
            <div className="job-card" key={job.id}>
              <span className="job-badge">{job.type}</span>

              <h2>{job.title}</h2>
              <h4>{job.company}</h4>

              <p><strong>Location:</strong> {job.location}</p>
              <p><strong>Salary:</strong> {job.salary}</p>

              {job.postedDate && (
                <p><strong>Posted:</strong> {job.postedDate}</p>
              )}

              <p className="job-description">
                {job.description}
              </p>

              {job.applyLink ? (
                <a
                  href={job.applyLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="apply-btn"
                >
                  Apply Now 🚀
                </a>
              ) : (
                <button className="apply-btn">
                  Apply Now 🚀
                </button>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default Jobs;